(function () {
  'use strict';

  // Suppress unverified urgency labels and untranslated lead popups configured
  // by the third-party Vitals app while leaving its other features untouched.
  if (window.vtlsLiquidData) {
    window.vtlsLiquidData.productLabels = [];
    window.vtlsLiquidData.popUps = [];
  }

  function initGallery(root) {
    var buttons = root.querySelectorAll('[data-ryza-thumb]');
    var slides = root.querySelectorAll('[data-ryza-slide]');
    if (!buttons.length || !slides.length) return;
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var target = button.getAttribute('data-ryza-thumb');
        buttons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        slides.forEach(function (slide) { slide.classList.toggle('is-active', slide.getAttribute('data-ryza-slide') === target); });
      });
    });
  }

  function initProduct(root) {
    var form = root.querySelector('.ryza-product-form');
    if (!form) return;
    var quantity = form.querySelector('[name="quantity"]');
    var offerInputs = form.querySelectorAll('[data-ryza-offer]');
    var mainButton = form.querySelector('[data-ryza-submit]');
    var sticky = document.querySelector('[data-ryza-sticky]');
    var stickyButton = sticky && sticky.querySelector('[data-ryza-sticky-submit]');
    var stickyMeta = sticky && sticky.querySelector('[data-ryza-sticky-meta]');

    function syncOffer(input) {
      if (!input || !input.checked) return;
      quantity.value = input.getAttribute('data-quantity') || '1';
      var label = input.getAttribute('data-button-label');
      var meta = input.getAttribute('data-meta');
      if (label && mainButton) mainButton.textContent = label;
      if (label && stickyButton) stickyButton.textContent = label;
      if (meta && stickyMeta) stickyMeta.textContent = meta;
    }

    offerInputs.forEach(function (input) {
      input.addEventListener('change', function () { syncOffer(input); });
      syncOffer(input);
    });

    var variantInputs = form.querySelectorAll('[data-ryza-variant]');
    var variantId = form.querySelector('[name="id"]');
    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked && variantId) variantId.value = input.value;
      });
    });

    if (sticky && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
      }, { threshold: 0 });
      observer.observe(form);
    }
  }

  function initMobileMenus(root) {
    root.querySelectorAll('.ryza-mobile-menu__panel a').forEach(function (link) {
      link.addEventListener('click', function () {
        var details = link.closest('details');
        if (details) details.removeAttribute('open');
      });
    });
  }

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-ryza-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-ryza-product]').forEach(initProduct);
    initMobileMenus(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
